import '../../app.es6';
import angular from 'angular';

class SchoolListController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();

    // 当機能はstaff権限のみ
    let role = localStorage.getItem(this.Const.LSAPP_ROLE);
    if (role === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    } else if (role === this.Const.LSAPP_ROLE_C_ADMIN) {
      this.$location.path('/admin/school');
    } else if (role === this.Const.LSAPP_ROLE_S_ADMIN) {
      this.$location.path('/admin');
    }

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    this.schoolList = [];
    this.commonApiFactory.getStaffsMeCourses()
    .then((courses) => {
      if (courses.length === 0) {
        this.$location.path('/staff');
        return;
      }

      // course情報からschool情報を生成
      let schools = [];
      courses.forEach((v) => {
        let school = {
          schoolId: v.schoolId,
          schoolName: v.schoolName
        };
        schools.push(school);
      });
      // 生成したschool情報の重複分を削除
      this.schoolList = schools.filter((v1, i, arr) => {
        return (arr.findIndex((v2) => {
          return (v1.schoolId === v2.schoolId);
        }) === i);
      });

      if (this.schoolList.length > 0) {
        this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = this.schoolList[0].schoolId;
        this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = this.schoolList[0].schoolName;
        if (this.schoolList.length === 1) {
          this.$location.path('/staff');
          return;
        }
      }

      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      console.error('error : ', error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });

    SchoolListController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  toCoachTop (school) {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID] = school.schoolId;
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = school.schoolName;
    this.$location.path('/staff');
  }
}

angular.module('myApp').controller('SchoolListController', SchoolListController);



// WEBPACK FOOTER //
// ./app/components/school-list/school-list-controller.es6